import { Box, Typography } from '@mui/material'
import Background from '../../ui/modules/auth/background'
import useStyles from './styles'
import useTranslations from '../../i18n/useTranslations'

const Maintenance = () => {
  const classes = useStyles()
  const t = useTranslations()

  return (
    <Background>
      <Box className={classes.textWrapper}>
        <Typography variant="h1" className={classes.title}>
          {t('noun:maintenance')}
        </Typography>
        <Typography variant="h2" className={classes.secondary}>
          {t('noun:sorry-for-inconveniences')}
        </Typography>
      </Box>
    </Background>
  )
}

export default Maintenance
